import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { MaterialsQaqcGroupDto } from '@models/materials-qaqc-dto.interface';

@Injectable({
  providedIn: 'root'
})
export class MaterialsQaqcService {
  private apiService = inject(ApiService);

  getMaterialsQaqc(jobId: number): Observable<MaterialsQaqcGroupDto[]> {
    return this.apiService.get(`jobs/${jobId}/materials-qaqc`) as Observable<MaterialsQaqcGroupDto[]>;
  }
}
